import { render, staticRenderFns } from "./ConferenceDetail.vue?vue&type=template&id=2c526902&scoped=true&"
import script from "./ConferenceDetail.vue?vue&type=script&lang=js&"
export * from "./ConferenceDetail.vue?vue&type=script&lang=js&"
import style1 from "./ConferenceDetail.vue?vue&type=style&index=1&id=2c526902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c526902",
  null
  
)

export default component.exports